export const selectInvoices = {
  name: [
    'ÚLTIMA SEMANA',
    'ÚLTIMOS 15 DIAS',
    'ÚLTIMO MÊS',
    'ÚLTIMOS 3 MESES',
    'ÚLTIMOS 6 MESES',
    'ÚLTIMO ANO',
    'TODOS',
  ],
  value: [
    '0.25',
    '0.50',
    '1',
    '3',
    '6',
    '12',
    '10000',
  ],
};

// TODO: alterar quando corrigir situação do boleto no itau
export const selectFilter = {
  name: [
    'TODOS',
    'PENDENTE',
    // `VENCIDO`,
    'PAGO',
  ],
  value: [
    null,
    'created',
    // `expired`,
    'paid',
  ],
};

export const selectFilterInvoice = {
  name: [
    'TODOS',
    'PENDENTE',
    'PAGO',
  ],
  value: [
    null,
    'created',
    'paid',
  ],
};
